import { render, staticRenderFns } from "./automationRuleTree.vue?vue&type=template&id=3c84ba8b&"
import script from "./automationRuleTree.vue?vue&type=script&lang=js&"
export * from "./automationRuleTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports